/* T.LUXY: reposition Wishlist Hero's REAL product button next to Add to cart.
 * Never clones or replaces the app button; its own click handling remains intact.
 */
(() => {
  'use strict';
  const APP_SELECTOR = '.wishlisthero-product-page-button-container';
  let queued = false;
  let observer;

  function locateWidget(slot) {
    const existing = slot.querySelector(APP_SELECTOR);
    if (existing) return existing;
    const area = document.querySelector('.shopify-section--product .product-single__details') || document;
    return area.querySelector(APP_SELECTOR) || document.querySelector(APP_SELECTOR);
  }

  function placeWishlist() {
    const actions = document.querySelector('.shopify-section--product .tluxy-purchase-actions');
    if (!actions) return;
    const slot = actions.querySelector('[data-tluxy-wishlist-slot]');
    if (!slot) return;
    const widget = locateWidget(slot);
    if (!widget) return;
    if (!slot.contains(widget)) {
      slot.appendChild(widget);
    }
    widget.querySelectorAll('button').forEach(button => {
      // App buttons may lack an explicit type; do not submit the Shopify cart form.
      if (button.type !== 'button') button.type = 'button';
    });
    actions.classList.add('tluxy-purchase-actions--wishlist-ready');
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      placeWishlist();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
  observer = new MutationObserver(schedule);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', schedule);
})();
